export const API_URLS = {
	GET_TOP_INVESTORS: '/charts/top-investors',
	CREATE_FINANCIAL_ASSISTANCE: '/public/financial-assistance-store',

	//Users
	GET_USERS_PAGINATED: '/users',
	GET_USERS: '/users/all',
	GET_USERS_BY_ID: '/users',
	UPDATE_USER: '/users',
	CREATE_USER: '/users',
	DELETE_USER: '/users',

	GET_BUDGETS_GROUPS_BY_USER: '/budgets/groups',
	GET_RANDOM_VERSE: '/panel/random-verse',
	GET_PANEL_DATA: '/panel',
	GET_BUDGETS_SUBGROUPS_BY_USER: '/budgets/subgroups',
	GET_BUDGETS_SUMMARY: '/budgets/index',
	DELETE_BUDGETS_GROUP: '/budgets/delete-group',
	DELETE_BUDGETS_SUBGROUP: '/budgets/delete-subgroup',
	CREATE_BUDGETS_GROUP: '/budgets/create-group',
	CREATE_BUDGETS_SUBGROUP: '/budgets/create-subgroup',
	CREATE_BUDGETS_MOVEMENT: '/budgets/create-movement',
	CREATE_BUDGETS_ASSET: '/budgets/create-asset',
	CREATE_BUDGETS_LIABILITY: '/budgets/create-liability',

	GET_EXPENSES: '/budgets/expenses',
	DELETE_EXPENSE: '/budgets/delete-expense',
	GET_INCOMES: '/budgets/incomes',
	DELETE_INCOME: '/budgets/delete-income',
	GET_INVESTMENTS: '/budgets/investments',
	DELETE_INVESTMENT: '/budgets/delete-investment',
	GET_ASSETS: '/budgets/assets',
	DELETE_ASSET: '/budgets/delete-asset',
	GET_LIABILITIES: '/budgets/liabilities',
	DELETE_LIABILITY: '/budgets/delete-liability',

	// Payments
	GET_ALL_PAYMENTS: '/payments',
	GET_USERS_WITH_DEBTS: '/payments/get-users-with-debts',
	CREATE_PAYMENT: '/payments',
	CREATE_TOTAL_PAYMENT: '/payments/total-liquidation',
	GET_PAYMENT_BY_ID: '/payments',
	GET_PAYMENTS_BY_USER: '/payments/user',
	DELETE_PAYMENT: '/payments',
	UPDATE_PAYMENT: '/payments',

	// Credit Portfolio
	GET_CREDIT_PORTFOLIO: '/credit-portfolios',
	GET_ALL_CREDIT_PORTFOLIO: '/credit-portfolios/user',

	// Amortizations
	GET_ALL_AMORTIZATIONS_BY_PORTFOLIO: '/amortizations/credit-portafolio',

	// investments
	GET_ALL_INVESTMENTS: '/investments',
	CREATE_INVESTMENT: '/investments',

	// transactions
	GET_ALL_TRANSACTIONS: '/transactions',
	CREATE_TRANSACTION: '/transactions',
	GET_BUDGET_TRANSACTIONS: '/budgets/transactions',

	// type transactions
	GET_ALL_TYPE_TRANSACTIONS: '/type-loans',

	// interest
	GET_ALL_INTEREST: '/interests',
	CREATE_INTEREST: '/interests',
	IMPORT_INTEREST: '/interests/import',
	EXPORT_INTEREST: '/interests/export',
	DOWNLOAD_INTEREST_TEMPLATE: '/interests/download-template',
	DELETE_INTEREST: '/interests',

	// Asistencias financieras
	FINANCIAL_ASSISTANCE_INIT: '/public/financial-assistance-init',
	GET_ALL_FINANCIAL_ASSISTANCE: '/financial-assistants',
	FINANCIAL_ASSISTANCE_INIT_AMORTIZATION_FORM:
		'/financial-assistants/init-form-generate-amortization',
	FINANCIAL_ASSISTANCE_CREATE_AMORTIZATION_PLAN:
		'/financial-assistants/generate-amortization',
	FINANCIAL_ASSISTANCE_GENERATE_AMORTIZATION_PDF:
		'/financial-assistants/generate-amortization-pdf',
	DELETE_FINANCIAL_ASSISTANCE: '/financial-assistants',
	UPDATE_FINANCIAL_ASSISTANCE: '/financial-assistants',
	FINANCIAL_ASSISTANCE_PAYMENTS: '/financial-assistants',
	FINANCIAL_ASSISTANCE_PAYMENTS_QUOTA: '/financial-assistants/payments',
	FINANCIAL_ASSISTANCE_PAYMENTS_LIST: '/financial-assistants/payments/list',
	UPDATE_FINANCIAL_ASSISTANCE_STATUS: '/financial-assistants/change-status',
	DELETE_FINANCIAL_ASSISTANCE_PAYMENT: '/financial-assistants/payments',

	// Settings
	GET_ALL_SETTINGS: '/settings',
	UPDATE_SYSTEM_SETTINGS: '/settings',

	// Credit
	GET_ALL_CREDIT: '/credit-portfolios',
	CREATE_CREDIT_PORTFOLIO: '/credit-portfolios',
	DELETE_CREDIT_PORTFOLIO: '/credit-portfolios',

	// Amortization
	CREATE_AMORTIZATION: '/amortizations',
	DELETE_AMORTIZATION: '/amortizations',
	GET_ALL_AMORTIZATION: '/amortizations',
	IMPORT_AMORTIZATION: '/amortizations/import',
	EXPORT_AMORTIZATION: '/amortizations/export',
	DOWNLOAD_AMORTIZATION_TEMPLATE: '/amortizations/import-template',
	GET_AMORTIZATION_BY_USER_ID: '/amortizations/user',

	// Solicitudes de préstamos
	GET_LOAN_REQUESTS_PAGINATED: '/loan-requests/index',
	CREATE_LOAD_REQUEST: '/loan-requests/store',
	GET_LOAD_REQUESTS_INIT_FORM: '/loan-requests/init-form',
	LOAD_REQUEST_INIT_AMORTIZATION_FORM:
		'/loan-requests/init-form-generate-amortization',
	CREATE_AMORTIZATION_PLAN: '/loan-requests/generate-amortization',

	// Rondas de inversión
	GET_ALL_INVESTMENT_ROUNDS: '/investment-rounds',
	CREATE_INVESTMENT_ROUND: '/investment-rounds',
	DELETE_INVESTMENT_ROUND: '/investment-rounds',

	// Debts
	GET_DEBTS: '/debits',
	INIT_PAGE_DEBT: '/debits/init-page',
	GET_DEBIT_SUMMARY: '/debits/get-summary',

	// Financial Statements
	GET_FINANCIAL_STATEMENT_BY_USER: '/financial-statements/user',

	// Retiro de fondos
	GET_WITHDRAWAL_INIT_FORM: '/withdrawal/init-form',
	CREATE_WITHDRAWAL: '/withdrawal/store',

	// Solicitudes de retiro de fondos
	GET_WITHDRAWAL_REQUESTS: '/withdrawal/index',
	UPDATE_WITHDRAWAL_STATUS: '/withdrawal/change-status',

	// Banks
	GET_ALL_BANKS: '/banks',
	GET_BANK_BY_ID: '/banks',
	CREATE_BANK: '/banks',
	UPDATE_BANK: '/banks',
	DELETE_BANK: '/banks',

	// family groups
	FAMILY_GROUPS: '/family-groups',

	// transactions
	MATER_GET_ALL_TRANSACTIONS: '/transactions',
	MATER_GET_TRANSACTION_BY_ID: '/transactions',
	MASTER_CREATE_TRANSACTION: '/transactions',
	MASTER_UPDATE_TRANSACTION: '/transactions',
	MASTER_DELETE_TRANSACTION: '/transactions',

	// Calendar
	GET_CALENDAR_EVENTS: '/calendar/events',
};
